<template>
  <title-container title="Application" icon="file-signature">
    <i class="mdi mdi-pencil-box"></i>
    <profile-tabs :index="tab" />
  </title-container>
</template>

<script>
import ProfileTabs from '@/components/profile/sections/tabs/ProfileTabs';
import TitleContainer from '@/components/utils/TitleContainer';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faFileSignature } from '@fortawesome/free-solid-svg-icons';
import {
  APPLICATION_TAB,
  FINANCIAL_TAB,
} from '@/components/profile/sections/tabs/tabNumbers';

library.add(faFileSignature);
export default {
  name: 'BorrowerApplicationPage',
  components: { TitleContainer, ProfileTabs },
  data: () => ({
    tab: 0,
    APPLICATION_TAB,
    FINANCIAL_TAB,
  }),
  computed: {
    profile() {
      return this.$store.getters.profile;
    },
  },
  mounted() {
    if (this.$route.query.tab) {
      this.tab = parseInt(this.$route.query.tab, 10);
    } else {
      this.incompleteTabIndexFind();
    }
  },
  methods: {
    incompleteTabIndexFind() {
      const missingItems = this.profile.missing;

      const reviewTab = APPLICATION_TAB;
      const tabCategories = [
        'agreement',
        'contact',
        'employment',
        'finances',
        'declarations',
        'demographics',
        'realEstateExperience',
      ];
      let tabIndexRunner = reviewTab;
      tabCategories.forEach((value, index) => {
        const tabIndexBeforeReviewTab = index < tabIndexRunner;
        tabIndexRunner =
          missingItems[value] && tabIndexBeforeReviewTab
            ? index
            : tabIndexRunner;
      });
      if (tabIndexRunner === FINANCIAL_TAB) {
        tabIndexRunner = APPLICATION_TAB;
      }
      this.tab = tabIndexRunner;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/borrower_application/BorrowerApplicationPage.vue